import { render, staticRenderFns } from "./SidebarIcon.vue?vue&type=template&id=5253eee2&scoped=true"
import script from "./SidebarIcon.vue?vue&type=script&lang=js"
export * from "./SidebarIcon.vue?vue&type=script&lang=js"
import style0 from "./SidebarIcon.vue?vue&type=style&index=0&id=5253eee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253eee2",
  null
  
)

export default component.exports